export default {
  additionalCostDatabase: 'Database Biaya Tambahan',
  searchText: 'Cari Biaya Tambahan',
  item: 'Item',
  edit: 'Ubah Entri Biaya Tambahan',
  create: 'Buat Entri Biaya Tambahan',
  addedTax: 'dikenakan pajak',
}
